import { ImportGrund } from "./import-grund";
import { clonePraeparat, Praeparat, PraeparatCmd } from "./praeparat";
import { Status } from "@app/shared/classes/status";
import { Land } from "@app/shared/classes/land";
import { DokumentRequired } from "@app/shared/classes/dokument-required";
import { MeldungArt } from "@app/shared/classes/meldung-art";
import { Notiz } from "@app/shared/classes/notiz";

export interface Meldung {
  id                : number;
  art               : MeldungArt;
  nummer            : string;
  erfDate           : Date;
  uid               : string;
  burNr             : number;
  praxis            : string;
  vorname           : string;
  nachname          : string;
  email             : string;
  telefon           : string;
  grund             : ImportGrund;
  grundKommentar    : string;
  importLand       ?: Land;
  haendlerAusland   : string;
  hauptIndikation   : string;
  kommentar         : string;
  praeparat         : Praeparat;
  status            : Status;
  stornoKommentar   : string;
  highlight         : string;
  neueDokumente     : number[];
  requiredDokumente : DokumentRequired;
  notiz             : Notiz;
}

export class MeldungCmd {
  uid               : string           | null = null;
  praxis            : string           | null = null;
  vorname           : string           | null = null;
  nachname          : string           | null = null;
  email             : string           | null = null;
  telefon           : string           | null = null;
  grund             : ImportGrund      | null = null;
  grundKommentar    : string           | null = null;
  importLand        : Land             | null = null;
  haendlerAusland   : string           | null = null;
  hauptIndikation   : string           | null = null;
  kommentar         : string           | null = null;
  praeparat         : PraeparatCmd            = new PraeparatCmd();
  neueDokumente     : number[]                = [];

  public constructor(init?: Partial<MeldungCmd>) {
    Object.assign(this, init);
  }

  static fromJSON(json: string | object): MeldungCmd {
    const object = typeof json === 'string' ? JSON.parse(json) : json;
    return new MeldungCmd(object);
  }
}

export function cloneMeldung(original?: Meldung): MeldungCmd {
  return new MeldungCmd({
    uid             : original?.uid,
    praxis          : original?.praxis,
    vorname         : original?.vorname,
    nachname        : original?.nachname,
    email           : original?.email,
    telefon         : original?.telefon,
    grund           : original?.grund,
    grundKommentar  : original?.grundKommentar,
    importLand      : original?.importLand,
    haendlerAusland : original?.haendlerAusland,
    hauptIndikation : original?.hauptIndikation,
    kommentar       : original?.kommentar,
    praeparat       : clonePraeparat(original?.praeparat),
    neueDokumente   : original?.neueDokumente,
  });
}
